(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/bomben-match.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/bomben-match.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.views.BombenMatch = Backbone.Marionette.View.extend({
    className: 'list-group-item',
    tagName: 'li',

    modelEvents: {
      change: 'render'
    },

    template: function(data) {
      return svs.tipset.templates.bombenmatch(data);
    },

    onDomRefresh: function() {
      this.trigger('childUpdated');
    }
  });
})(Backbone, _, svs);

 })(window);